import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {
    collaboratorContracts: [],
    contractTypes: [],
    contractBasicDocument: null,
  }
}

export const state = getDefaultState()

export const getters = {
  getContractTypeTypes: (state) => () => {
    return [
      ...new Set(state.contractTypes.map((contractType) => contractType.type)),
    ]
  },
}

export const mutations = {
  UPDATE_COLLABORATOR_CONTRACTS(state, collaboratorContracts) {
    state.collaboratorContracts = collaboratorContracts
  },
  UPDATE_CONTRACT_TYPES(state, contractTypes) {
    state.contractTypes = contractTypes
  },
  UPDATE_CONTRACT_BASIC_DOCUMENT(state, contractBasicDocument) {
    state.contractBasicDocument = contractBasicDocument
  },
  RESET_CONTRACT_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  // COLLABORATOR CONTRACTS
  // GET
  async fetchCollaboratorContracts(store) {
    try {
      const res = await axios.get('api/contracts')
      store.commit('UPDATE_COLLABORATOR_CONTRACTS', res.data)
    } catch (error) {
      throw new Error('API Error occurred in api/contracts.')
    }
  },

  // CONTRACT TYPES
  // GET
  async fetchContractTypes(store, filters = {}) {
    try {
      const filtersArr = []
      Object.keys(filters).forEach(function (key) {
        if (filters[key] !== null || filters[key] !== undefined) {
          filtersArr.push(`${key}=${filters[key]}`)
        }
      })
      const queryParams =
        filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
      const res = await axios.get(
        `${BASE}/mx/api/v2/contractTypes${queryParams}`,
      )
      store.commit('UPDATE_CONTRACT_TYPES', res.data)
    } catch (error) {
      throw new Error('API Error occurred in /mx/api/v2/contractTypes.')
    }
  },

  // Get contract document.
  // GET
  async fetchContractBasicDocumentAction(store, filters = {}) {
    try {
      store.commit('UPDATE_CONTRACT_BASIC_DOCUMENT', null)
      const res = await axios.get(
        `${BASE}/mx/api/v2/contracts/document.summary/collaborator/${filters.collaboratorUuid}/startDate/${filters.contractStartDate}`,
      )
      store.commit('UPDATE_CONTRACT_BASIC_DOCUMENT', res.data)
    } catch (error) {
      throw new Error(
        `API Error occurred in ${BASE}/mx/api/v2/contracts/document.summary/collaborator/${filters.collaboratorUuid}/startDate/${filters.contractStartDate}`,
      )
    }
  },
}
